import React from "react";
import { Box } from "@material-ui/core";
import { PageTitle } from "../../components/common/pageTitle";
import { RemontWrapper } from "../../components/common/RemontWrapper";
import { CheckRemontPermission } from "../remonts/CheckRemontPermission";
import ContragentAvr from "../remonts/ContragentAvr";

export const RemontAvr = () => {
  return (
    <CheckRemontPermission>
      <RemontWrapper>
        <PageTitle title="АВР" />
        <Box style={{ padding: 20 }}>
          <ContragentAvr />
        </Box>
      </RemontWrapper>
    </CheckRemontPermission>
  );
};
